import type { EmployeeWorkStatus } from '../../types/dashboard';

interface StatusDotProps {
  status: EmployeeWorkStatus;
  pulse?: boolean;
  size?: 'sm' | 'md';
}

const STATUS_TONE: Record<EmployeeWorkStatus, string> = {
  in: 'bg-status-full',
  break: 'bg-status-partial',
  absent: 'bg-accent',
  missing: 'bg-status-conflict',
  out: 'bg-ink-faint',
};

const STATUS_PULSE: Record<EmployeeWorkStatus, string> = {
  in: 'bg-emerald-400',
  break: 'bg-amber-300',
  absent: 'bg-sky-300',
  missing: 'bg-red-400',
  out: 'bg-slate-300',
};

export function StatusDot({ status, pulse = false, size = 'sm' }: StatusDotProps) {
  const dotSize = size === 'sm' ? 'w-2 h-2' : 'w-2.5 h-2.5';
  const ringSize = size === 'sm' ? 'w-3 h-3' : 'w-4 h-4';
  return (
    <span className="relative inline-flex items-center justify-center">
      {pulse && (
        <span
          className={`absolute inline-flex ${ringSize} rounded-full opacity-75 animate-ping ${STATUS_PULSE[status]}`}
        />
      )}
      <span className={`relative inline-flex rounded-full ${dotSize} ${STATUS_TONE[status]}`} />
    </span>
  );
}
